import React from 'react';

function InitLoader() {
  return (
    <div
      className="d-flex justify-content-center flex-column align-items-center"
      style={{ height: '100vh', fontSize: 20, fontWeight: '700' }}>
      <img style={{ height: 50 }} src="/img/general/SP2_logo_black.png" alt="logo icon" />
      <p className="text-dark">Loading...</p>
    </div>
  );
}

export default InitLoader;
